import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getRelatedOrganisationList from "../http/getRelatedOrganisationList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useRelatedOrganisationList = (
  orgId: string | undefined,
  userOrgIdParam?: string
) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchRelatedOrganisations = useQuery(
    ["relatedOrganisations", orgId],
    async () => {
      return getRelatedOrganisationList(
        await getAuthTokenBlocking(getToken, relogin),
        orgId!,
        await getUserOrgId(getClaim, userOrgIdParam)
      );
    },
    { enabled: !!orgId }
  );

  return {
    fetchRelatedOrganisations,
  };
};

export default useRelatedOrganisationList;
